import { jsx as g, jsxs as y } from "react/jsx-runtime";
import { c as f } from "./clsx-OuTLNxxd.js";
import b, { useState as p, useId as h, useEffect as S } from "react";
import { C as z } from "./ChevronDown-CX8GzN8D.js";
const W = "320px", B = "600px", E = "1025px", I = "_isVisuallyHidden_n537l_51", N = "_header_n537l_63", k = "_triggerElement_n537l_67", A = "_indicator_n537l_70", C = "_trigger_n537l_67", V = "_contentElement_n537l_89", v = "_content_n537l_89", P = "_primary_n537l_98", w = "_item_n537l_98", $ = "_secondary_n537l_135", i = {
  mobile: W,
  "mobile-wide": "480px",
  tablet: B,
  "tablet-wide": "800px",
  desktop: E,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: I,
  header: N,
  triggerElement: k,
  indicator: A,
  trigger: C,
  contentElement: V,
  content: v,
  primary: P,
  item: w,
  secondary: $
}, j = ({
  isOpen: e,
  onChange: l
}) => {
  const [t, a] = p(e), s = h(), x = h(), n = () => {
    l && l(!t), a(!t);
  };
  S(() => {
    e !== t && a(e);
  }, [e]);
  const m = {
    "aria-controls": x,
    "aria-expanded": e,
    "data-state": t ? "open" : "closed",
    id: s,
    onClick: n
  }, r = {
    "aria-labelledby": s,
    className: i.contentElement,
    hidden: !t,
    id: x,
    role: "region"
  };
  return {
    headingProps: m,
    sectionProps: r,
    triggerClass: i.triggerElement,
    Indicator: () => /* @__PURE__ */ g(z, { size: "s", className: i.indicator })
  };
}, u = ({
  heading: e,
  isOpen: l = !1,
  children: t,
  onChange: a,
  trackingAttribute: s
}) => {
  const { headingProps: x, sectionProps: n, Indicator: m, triggerClass: r } = j({
    isOpen: l,
    onChange: a
  });
  return /* @__PURE__ */ y("div", { className: i.item, children: [
    /* @__PURE__ */ g("h3", { className: i.header, children: /* @__PURE__ */ y(
      "button",
      {
        className: f(r, i.trigger),
        ...x,
        ...s ? { "data-analytics": s } : {},
        children: [
          e,
          /* @__PURE__ */ g(m, {})
        ]
      }
    ) }),
    /* @__PURE__ */ g("div", { ...n, className: i.content, children: t })
  ] });
}, D = ({
  children: e,
  name: l,
  defaultOpen: t,
  type: a = "single",
  variant: s = "primary"
}) => {
  const x = a === "multiple", n = b.Children.toArray(e), m = t ? n.map(() => !0) : n.map((o) => !!o.props.isOpen), [r, _] = p(m), H = (o, d) => {
    let c = [];
    x ? (c = [...r], c[d] = o) : (c = n.map(() => !1), o === !0 && (c[d] = !0)), _(c);
  };
  return /* @__PURE__ */ g(
    "div",
    {
      className: f(i.accordion, i[`${s}`]),
      "data-testid": "accordion-component",
      children: e && n.map((o, d) => /* @__PURE__ */ g(
        u,
        {
          isOpen: r[d],
          heading: o.props.heading,
          onChange: (c) => H(c, d),
          trackingAttribute: o.props.trackingAttribute,
          children: o.props.children
        },
        `${l}-item-${d}`
      ))
    }
  );
};
D.Item = u;
export {
  D as A,
  j as u
};
